import { render, staticRenderFns } from "./DishCell.vue?vue&type=template&id=60872bee&scoped=true&lang=pug"
import script from "./DishCell.vue?vue&type=script&lang=js"
export * from "./DishCell.vue?vue&type=script&lang=js"
import style0 from "./DishCell.vue?vue&type=style&index=0&id=60872bee&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60872bee",
  null
  
)

export default component.exports